import { lazy } from 'react'

export const ActivateAppModalAsync = lazy(() =>
	import('./ActivateAppModal').then((module) => ({
		default: module.ActivateAppModal
	}))
)